var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("TitleWithRow", {
        attrs: { title: "Atividades agrícolas e produtividade" }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("InputSelect", {
            attrs: {
              label: "Cultura",
              nomeAba: _vm.nomeAba,
              obrigatorio: true,
              rulesInput: !_vm.pratica.lavouras.length ? "required" : "",
              opcoes: _vm.culturas,
              widthColumn: 8
            },
            model: {
              value: _vm.atividade.cultura,
              callback: function($$v) {
                _vm.$set(_vm.atividade, "cultura", $$v)
              },
              expression: "atividade.cultura"
            }
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: !_vm.pratica.lavouras.length ? "required" : "",
              name: _vm.nomeAba + "/Qual cultura "
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _vm.containsOption(
                      _vm.atividade.cultura,
                      "OUTROS",
                      "especificacaoOutros"
                    )
                      ? _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c("Label", {
                              attrs: {
                                label: "Qual cultura?",
                                obrigatorio: !_vm.pratica.lavouras.length
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              class: { "input erro": errors.length },
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.atividade.especificacaoOutros,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.atividade,
                                    "especificacaoOutros",
                                    $$v
                                  )
                                },
                                expression: "atividade.especificacaoOutros"
                              }
                            }),
                            _vm._v(" "),
                            errors[0]
                              ? _c("span", { staticClass: "help erro" }, [
                                  _vm._v(" " + _vm._s(errors[0]))
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("validation-provider", {
            attrs: {
              rules: !_vm.pratica.lavouras.length ? "required" : "",
              name: _vm.nomeAba + "/Espaçamento "
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("Label", {
                          attrs: {
                            label: "Espaçamento (m)",
                            obrigatorio: !_vm.pratica.lavouras.length
                          }
                        }),
                        _vm._v(" "),
                        _c("el-input", {
                          class: { "input erro": errors.length },
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "Ex: 20 x 20", clearable: "" },
                          model: {
                            value: _vm.atividade.espacamento,
                            callback: function($$v) {
                              _vm.$set(_vm.atividade, "espacamento", $$v)
                            },
                            expression: "atividade.espacamento"
                          }
                        }),
                        _vm._v(" "),
                        errors[0]
                          ? _c("span", { staticClass: "help erro" }, [
                              _vm._v(" " + _vm._s(errors[0]))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            width: "100%",
            top: "20px",
            display: "flex",
            "justify-content": "flex-end"
          }
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                disabled: _vm.disableButton,
                round: "",
                type: "primary"
              },
              on: {
                click: function($event) {
                  return _vm.btnAdicionar()
                }
              }
            },
            [_vm._v("\n      Adicionar\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
        _vm._l(_vm.pratica.lavouras, function(l, i) {
          return _c(
            "div",
            { key: i + l.cultura },
            [
              _c("Card", {
                attrs: {
                  objeto: Object.assign({}, l, {
                    cultura: _vm.pratica.lavouras
                      ? _vm.culturas.find(function(lavoura) {
                          return lavoura.id === l.cultura
                        }).nome
                      : "-"
                  }),
                  deletar: function() {
                    return _vm.btnApagar(i)
                  },
                  editar: function() {
                    return _vm.btnEditar(l, i)
                  },
                  titulo: "Lavoura"
                }
              })
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0345a5e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0345a5e5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/ILPF/IlpfLavoura.vue
// module id = null
// module chunks = 